import { SKILL_REPOSITORY, CONVERSATION_REPOSITORY, CREATE_CONVERSATION_USE_CASE, CreateConversationUseCase, GET_LLM_PROVIDERS_USE_CASE, GET_PROMPT_TEMPLATES_USE_CASE, GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE, GET_MESSAGES_USE_CASE, UPLOAD_CONVERSATION_FILES_USE_CASE, GetConversationsWithMessagesUseCase, GetLlmProvidersUseCase, GetMessagesUseCase, GetPromptTemplatesUseCase, UploadConversationFilesUseCase, MESSAGE_REPOSITORY, LLM_PROVIDER_REPOSITORY, PROMPT_TEMPLATE_REPOSITORY } from '../../../../ai';
export var conversationUseCaseProviders = [{
  provide: GET_CONVERSATIONS_WITH_MESSAGES_USE_CASE,
  useFactory: function useFactory(conversationRepository, skillRepository, messageRepository) {
    return new GetConversationsWithMessagesUseCase(conversationRepository, skillRepository, messageRepository);
  },
  inject: [CONVERSATION_REPOSITORY, SKILL_REPOSITORY, MESSAGE_REPOSITORY]
}, {
  provide: GET_MESSAGES_USE_CASE,
  useFactory: function useFactory(messageRepository) {
    return new GetMessagesUseCase(messageRepository);
  },
  inject: [MESSAGE_REPOSITORY]
}, {
  provide: GET_PROMPT_TEMPLATES_USE_CASE,
  useFactory: function useFactory(promptTemplateRepository) {
    return new GetPromptTemplatesUseCase(promptTemplateRepository);
  },
  inject: [PROMPT_TEMPLATE_REPOSITORY]
}, {
  provide: GET_LLM_PROVIDERS_USE_CASE,
  useFactory: function useFactory(llmProviderRepository) {
    return new GetLlmProvidersUseCase(llmProviderRepository);
  },
  inject: [LLM_PROVIDER_REPOSITORY]
}, {
  provide: CREATE_CONVERSATION_USE_CASE,
  useFactory: function useFactory(conversationRepository) {
    return new CreateConversationUseCase(conversationRepository);
  },
  inject: [CONVERSATION_REPOSITORY]
}, {
  provide: UPLOAD_CONVERSATION_FILES_USE_CASE,
  useFactory: function useFactory(conversationRepository) {
    return new UploadConversationFilesUseCase(conversationRepository);
  },
  inject: [CONVERSATION_REPOSITORY]
}];